import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/services/grants-and-funding")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Grants and Funding Strategy",
      description:
        "Grant research, eligibility review, and application preparation for founders and small businesses.",
      path: "/services/grants-and-funding",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"Grants and funding"} intro={"[SUPPLY: service detail copy]"} />;
}
